module.exports = __webpack_public_path__ + "img/mazda_thumbnail.02534d94.png";